/**
 * Reads the Sentry traces sample rate from a build-time string.
 *
 * The build args reach CRA as strings and can arrive absent or empty — preview
 * builds pass empty values for the Sentry vars. `Number('')` is `0`, which
 * would turn tracing off silently, so anything that is not a usable number
 * falls back to the default instead. An explicit `0` is honoured: that is how
 * an environment opts out (86bc02ugj).
 */
export const parseTracesSampleRate = (
  raw: string | undefined,
  fallback = 1.0
): number => {
  if (!raw) return fallback;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : fallback;
};
